import round from 'utils/round';
import { ORIENTATION } from './constants';

export function getDisplayPageSize(template, section = 'pages') {
  if (template.template.displaySizes) {
    return template.template.displaySizes[section];
  }
  return template.template.displaySize;
}

export function getPageSize(template, section = 'pages', span = false) {
  if (template.template.size) {
    const [width, height] = template.template.size;
    return [span ? width * 2 : width, height];
  }

  if (template.template.sizes) {
    const [width, height] = template.template.sizes[section];
    return [span ? width * 2 : width, height];
  }

  throw new Error('The template does not have page size specified.');
}

export function getBleedZone(template, page, section = 'pages') {
  if (template.template.bleed) {
    let pageNumber = page.index;
    if (!template.cover && section === 'pages') {
      pageNumber = page.index + 1;
    }
    const type = pageNumber % 2 === 0 ? 'even' : 'odd';
    const bleedZoneKey = [`${section}:${type}`, section].find(
      (key) => template.template.bleed[key],
    );
    const bleedZone = template.template.bleed[bleedZoneKey];
    if (bleedZone && bleedZone.length === 4) {
      return bleedZone;
    }
  }

  return undefined;
}

export function getSafeZoneFrame(pageWidth, pageHeight, bleed) {
  if (!bleed) {
    return [0, 0, pageWidth, pageHeight];
  }

  const [left, top, right, bottom] = bleed;
  return [left, top, pageWidth - left - right, pageHeight - top - bottom];
}

export function isFrameInSafeZone(safeFrame, placeholderFrame, angle = 0, offsetX = 0) {
  if (!safeFrame || !placeholderFrame) {
    return true;
  }

  if (angle !== 0) {
    return true;
  }

  const [safeX, safeY, safeWidth, safeHeight] = safeFrame.map((val) => round(val, 4));
  const [placeholderX, placeholderY, placeholderWidth, placeholderHeight] = placeholderFrame.map(
    (val) => round(val, 4),
  );

  if (placeholderX + offsetX < safeX || placeholderY < safeY) {
    return false;
  }

  if (placeholderX + offsetX + placeholderWidth > safeX + safeWidth) {
    return false;
  }

  if (placeholderY + placeholderHeight > safeY + safeHeight) {
    return false;
  }

  return true;
}

function orientationFromDimensions(width, height) {
  if (width === height) {
    return ORIENTATION.SQUARE;
  }
  if (width > height) {
    return ORIENTATION.LANDSCAPE;
  }
  return ORIENTATION.PORTRAIT;
}

export function getPhotoOrientationType(photo) {
  const { width, height } = photo;
  return orientationFromDimensions(width, height);
}

export function getPlaceholderOrientationType(placeholder) {
  const [, , width, height] = placeholder.frame;
  return orientationFromDimensions(width, height);
}

export function getSpineSize(template, numberOfPages) {
  // TODO this can be removed when everything is ready!
  if (!template.id.startsWith('book-')) {
    return undefined;
  }

  if (template.proxy?.spine) {
    const minimumNumberOfPages = Object.keys(template.proxy.spine)
      .map((key) => parseInt(key, 10))
      .sort((a, b) => b - a);

    if (minimumNumberOfPages.length > 0) {
      let key;
      if (numberOfPages < minimumNumberOfPages[minimumNumberOfPages.length - 1]) {
        key = minimumNumberOfPages[minimumNumberOfPages.length - 1];
      } else {
        key = minimumNumberOfPages.find((value) => {
          return numberOfPages >= value;
        });
      }
      if (key) {
        const value = template.proxy.spine[key];
        if (value) {
          return parseFloat(template.proxy.spine[key]);
        }
      }
    }
  }
  return null;
}
